import React from 'react';
import { FileText } from 'lucide-react';
import type { ReadDocumentWidgetData } from '../../../types/agentWidgets';
import { useDocumentViewer } from '../../../contexts/DocumentViewerContext';

interface Props {
  data: ReadDocumentWidgetData;
}

export const ReadDocumentWidget: React.FC<Props> = ({ data }) => {
  const { openDocument } = useDocumentViewer();

  return (
    <div className="mt-1.5 flex items-center gap-2 text-[11px] bg-emerald-50/70 dark:bg-emerald-900/10 rounded px-2 py-1.5 group">
      <FileText className="h-3 w-3 text-emerald-500 dark:text-emerald-400 flex-shrink-0" />
      <span className="font-medium text-emerald-700 dark:text-emerald-300 truncate flex-1 min-w-0">
        {data.documentName}
      </span>
      <span className="text-[10px] text-gray-400 dark:text-gray-500 whitespace-nowrap">
        {Math.round(data.textLength / 1000)}k chars
        {data.truncated && ' (truncated)'}
      </span>
      <button
        onClick={() =>
          openDocument({
            documentId: data.documentId,
            documentName: data.documentName,
          })
        }
        className="text-emerald-600 dark:text-emerald-400 hover:underline whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-medium"
      >
        Open
      </button>
    </div>
  );
};
